import React from 'react'
import Grid from 'components/grids/Grid'
import FormUpload from 'components/forms/FormUpload'
import FormTarget from 'components/forms/FormTarget';
import FormLink from 'components/forms/FormLink';
import FormInput from 'components/forms/bases/FormInput';
import Image from 'components/images/Image';

const inputStyle = { fontSize: 12 }

const FormImage = ({ className, style, children }) => {
  return (
    <Grid style={{ background: '#ffffff', margin: '0.25rem', ...style }} className={className}>
      {children}
    </Grid>
  )
}

FormImage.Column = Grid.Column
FormImage.Image = Image
FormImage.Upload = FormUpload
FormImage.Source = ({
  value,
  onChange,
  ...props,
}) => {
  return (
    <div>
      <FormUpload onChange={onChange} />
      <FormInput
        className={'none'}
        label="Source"
        inputStyle={inputStyle}
        {...props}
        value={value}
        onChange={onChange}
      />
    </div>
  )
}
FormImage.Link = ({ style, ...props }) => <FormLink inputStyle={{ ...inputStyle, ...style }} {...props}/>
FormImage.Target = (props) => <FormTarget labelStyle={inputStyle} {...props} />

export default FormImage




// WEBPACK FOOTER //
// ./src/components/forms/image/FormImage.js